export default function MemberItem(member, clickEvent) {
    return <div className="px-4 py-4 md:grid md:grid-cols-5 md:items-center" onClick={clickEvent}>
        <div className={`md:col-span-5 md:flex md:flex-col md:justify-between md:min-h-full`}>
            <div className="top-section w-full py-2">
                <div className="flex">
                    { <div className="avatar placeholder">
                    <div className="bg-neutral text-neutral-content rounded-full w-12">
                        <span>{ member.name[0] }</span>
                    </div>
                    </div> 
                    }
                    <div className="pl-4">
                        <div className="grow text-lg font-bold self-center text-base-content line-clamp-2">
                            { member.name }
                        </div>
                        <div className="grow text-base font-base self-center text-base-content line-clamp-2">
                            { member.email }
                        </div>
                    </div>
                </div>
        
            </div>
        </div>
    </div>
    
}